import script from "./user-profile.vue?vue&type=script&setup=true&lang=js"
export * from "./user-profile.vue?vue&type=script&setup=true&lang=js"

import "./user-profile.vue?vue&type=style&index=0&id=287fdf9f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-287fdf9f"]])

export default __exports__